import { render } from "./AboutPage.vue?vue&type=template&id=fe1e64d8&bindings={}"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
script.render = render

export default script